export default __webpack_public_path__ + "static/media/logo.2c372da7.png";